/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
import { hasOwnMetadata, defineMetadata, getOwnMetadata } from '../localReflect';
import constants from '../constants';
/**
 * Decorator: Specifies a custom registration strategy for the decorated class/function.
 */
export function Wrap(wrap) {
    return function (target) {
        if (hasOwnMetadata(constants.wrap, target)) {
            var exitingWrap_1 = getOwnMetadata(constants.wrap, target);
            defineMetadata(constants.wrap, {
                get: function (v, container, key) {
                    return wrap.get(exitingWrap_1.get(v, container, key), container, key);
                },
            }, target);
        }
        else {
            defineMetadata(constants.wrap, wrap, target);
        }
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid3JhcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIndyYXAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7O0dBS0c7QUFDSCxPQUFPLEVBQUMsY0FBYyxFQUFFLGNBQWMsRUFBRSxjQUFjLEVBQUMsTUFBTSxpQkFBaUIsQ0FBQztBQUMvRSxPQUFPLFNBQVMsTUFBTSxjQUFjLENBQUM7QUFHckM7O0dBRUc7QUFDSCxNQUFNLFVBQVUsSUFBSSxDQUFDLElBQTJCO0lBQzVDLE9BQU8sVUFBQyxNQUFXO1FBQ2YsSUFBSSxjQUFjLENBQUMsU0FBUyxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsRUFBRTtZQUN4QyxJQUFNLGFBQVcsR0FBMEIsY0FBYyxDQUNyRCxTQUFTLENBQUMsSUFBSSxFQUNkLE1BQU0sQ0FDVCxDQUFDO1lBQ0YsY0FBYyxDQUNWLFNBQVMsQ0FBQyxJQUFJLEVBQ2Q7Z0JBQ0ksR0FBRyxZQUFDLENBQUMsRUFBRSxTQUFTLEVBQUUsR0FBRztvQkFDakIsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLGFBQVcsQ0FBQyxHQUFHLENBQUMsQ0FBQyxFQUFFLFNBQVMsRUFBRSxHQUFHLENBQUMsRUFBRSxTQUFTLEVBQUUsR0FBRyxDQUFDLENBQUM7Z0JBQ3hFLENBQUM7YUFDcUIsRUFDMUIsTUFBTSxDQUNULENBQUM7U0FDTDthQUFNO1lBQ0gsY0FBYyxDQUFDLFNBQVMsQ0FBQyxJQUFJLEVBQUUsSUFBSSxFQUFFLE1BQU0sQ0FBQyxDQUFDO1NBQ2hEO0lBQ0wsQ0FBQyxDQUFDO0FBQ04sQ0FBQyJ9